$(document).ready(function(){
  var checkExist = setInterval(function() {
        if ($('.cdk-showmore-1 .col-md-6').length) {
            $(".cdk-showmore-1 .col-md-6").hide();
            $(".cdk-showmore-1 .col-md-6").slice(0, 12).fadeIn();
            $(document).on('click', '.showmore-option-1', function(e) {
                e.preventDefault();
                $(".cdk-showmore-1 .col-md-6:hidden").slice(0, 12).fadeIn();
                if ($(".cdk-showmore-1 .col-md-6:hidden").length == 0) {
                    $(".showmore-option-1").fadeOut('slow');
                }
            });
            clearInterval(checkExist);
        }
    }, 100);

  var checkExist2 = setInterval(function() {
        if ($('.cdk-showmore-2 .col-md-6').length) {
            $(".cdk-showmore-2 .col-md-6").hide();
            $(".cdk-showmore-2 .col-md-6").slice(0, 12).fadeIn();
            $(document).on('click', '.showmore-option-2', function(e) {
                e.preventDefault();
                $(".cdk-showmore-2 .col-md-6:hidden").slice(0, 12).fadeIn();
                if ($(".cdk-showmore-2 .col-md-6:hidden").length == 0) {
                    $(".showmore-option-2").fadeOut('slow');
                }
            });
            clearInterval(checkExist2);
        }
    }, 100);
  // setTimeout(function () {
  // $('.product-recommendations--container .product-row').flickity({
  //   // options
  //   cellAlign: 'left',
  //   contain: true,
  //   pageDots: false,
  //   adaptiveHeight: true
  // });
  // },500);
  $(document).on('change', '.product__container .product-form--regular .variant-selection .options-selection__input-select', function(){
      var variantIdmain = $(this).parents('.variant-selection').attr("variant");
      // console.log("variantIdmain::"+variantIdmain);
      var varaintVatprice = $(this).parents('.variant-selection').find(".variant-selection__variants option[value= '" +variantIdmain+ "' ]").attr("data--variant-price-vat");
      // console.log("varaintVatprice::"+varaintVatprice);
      $(this).parents('.product__container').find('.product-block--price .vat__price').text(varaintVatprice);
  });
// Quick wrapper
  // $(document).on('change', '.product-main .product-form--regular .variant-selection .options-selection__input-select', function(){
  //     var variantIdmain = $(this).parents('.variant-selection').attr("variant");
  //     // console.log("variantIdmain::"+variantIdmain);
  //     var varaintVatprice = $(this).parents('.variant-selection').find(".variant-selection__variants option[value= '" +variantIdmain+ "' ]").attr("data--variant-price-vat");
  //     // console.log("varaintVatprice::"+varaintVatprice);
  //     $(this).parents('.product-main').find('.product-block--price .vat__price').text(varaintVatprice);
  // });
  
  // range silder for  filter for height
  if ($.fn.slider) {
  var minValue = parseInt($('#min-height').attr('min'));
  var maxValue = parseInt($('#max-height').attr("max"));

  // Set initial values on the slider
  $('.range-slider-height').slider({
    range: true,
    min: 0,
    max: 200,
    values: [minValue, maxValue],
    slide: function (event, ui) {
      $('#min-height').val(ui.values[0]);
      $('#max-height').val(ui.values[1]);
    }
  });
  // Update slider height when input values change
  $('#min-height, #max-height').on('input', function () {
    var newMin = parseInt($('#min-height').val());
    var newMax = parseInt($('#max-height').val());

    // Update slider values
    $('.range-slider-height').slider('values', [newMin, newMax]);
  });
  // range silder for  filter for width
var minValueWidth = parseInt($('#min-width').attr('min'));
var maxValueWidth = parseInt($('#max-width').attr("max"));
  $('.range-slider-width').slider({
    range: true,
    min: 0,
    max: 200,
    values: [minValueWidth, maxValueWidth],
    slide: function (event, ui) {
      $('#min-width').val(ui.values[0]);
      $('#max-width').val(ui.values[1]);
    }
  });
  
  // Update slider width when input values change
  $('#min-width, #max-width').on('input', function () {
    var newMinWidth = parseInt($('#min-width').val());
    var newMaxWidth = parseInt($('#max-width').val());

    // Update slider values
    $('.range-slider-width').slider('values', [newMinWidth, newMaxWidth]);
  });
  } // end $.fn.slider guard (jQuery UI loads on collection/search pages only)

  $(document).on('click', '.filter__main .pt-filter-menu-container .pt-filter-drawer .pt-filter-drawer-header', function(){
    $(this).toggleClass('active');
    $(this).siblings('.filter-menu').slideToggle();
    // $(this).parents('.pt-filter-drawer').find('.filter-menu').slideToggle();
  });
   
})